// Configuração centralizada da URL da API
// Em produção, usar rotas relativas para aproveitar os redirecionamentos do Netlify
// Em desenvolvimento, usar a URL completa do backend local

export const getApiBaseUrl = () => {
  // Em produção: se REACT_APP_API_URL estiver definido, usar base absoluta.
  // Caso contrário, usar rotas relativas ("/api/..."), assumindo proxy/redirect no hosting.
  if (process.env.NODE_ENV === 'production') {
    let prodBase = process.env.REACT_APP_API_URL || '';
    prodBase = prodBase.replace(/\/+$/,'');
    prodBase = prodBase.replace(/\/api$/,'');
    const isSecure = typeof window !== 'undefined' && window.location && window.location.protocol === 'https:';
    if (isSecure && prodBase.startsWith('http://')) {
      prodBase = '';
    }
    return prodBase;
  }
  // Em desenvolvimento: se REACT_APP_USE_DEV_PROXY=true, usar rotas relativas e deixar o dev server proxyar
  if (String(process.env.REACT_APP_USE_DEV_PROXY || '').toLowerCase() === 'true') {
    return '';
  }
  // Caso contrário, apontar para o backend local (porta 3001), respeitando o protocolo do frontend (http/https)
  const proto = typeof window !== 'undefined' && window.location && window.location.protocol ? window.location.protocol : 'http:';
  const hostname = typeof window !== 'undefined' && window.location && window.location.hostname ? window.location.hostname : 'localhost';
  const host = process.env.HOST || hostname;
  let url = process.env.REACT_APP_API_URL || `${proto}//${host}:3001`;
  // Remover barras finais
  url = url.replace(/\/+$/, '');
  // Remover sufixo '/api' se presente
  url = url.replace(/\/api$/, '');
  if (proto === 'https:' && url.startsWith('http://')) {
    return '';
  }
  return url;
};

export const getApiUrl = (endpoint) => {
  const baseUrl = getApiBaseUrl().replace(/\/+$/, '');
  
  // Remover qualquer /api/ existente do endpoint para evitar duplicação
  let cleanEndpoint = endpoint;
  if (cleanEndpoint.startsWith('/api/')) {
    cleanEndpoint = cleanEndpoint.substring(5); // Remove '/api/'
  } else if (cleanEndpoint.startsWith('api/')) {
    cleanEndpoint = cleanEndpoint.substring(4); // Remove 'api/'
  }
  // Remover barra inicial se houver
  if (cleanEndpoint.startsWith('/')) {
    cleanEndpoint = cleanEndpoint.substring(1);
  }
  
  if (process.env.NODE_ENV === 'production') {
    // Em produção, se baseUrl estiver vazio, usar rotas relativas que serão redirecionadas pelo hosting.
    // Se baseUrl estiver definido (REACT_APP_API_URL), construir URL absoluta.
    return baseUrl
      ? `${baseUrl}/api/${cleanEndpoint}`
      : `/api/${cleanEndpoint}`;
  } else {
    // Em desenvolvimento, construir URL completa garantindo um único '/api'
    return `${baseUrl}/api/${cleanEndpoint}`;
  }
};
